<template>
    <div class="order-container">
    <Header title="专家咨询列表"></Header>
    <div class="tabs-container">
        <Scroll
        ref="wrapper"
        :listenScroll="false"
        :pullUpLoad="pullUpLoadObj"
        @pullingUp="onPullUpLoad"
        :pullDownRefresh="pullDownRefreshObj"
        @pullingDown="onPullDownRefresh"
      >
        <Cart
        v-for="(item,key) in complaint"
        :complaint="item"
        :key="key"
        />
      </Scroll>
      <!-- <van-empty
      class="custom-empty"
      description="暂无数据"
    ></van-empty> -->
    </div>
    </div>
</template>
<script>
import Header from "@/components/Header";
import Scroll from "@/components/Scroll";
import Cart from "./cart";
import transactionApi from "@/request/transactionApi";

export default {
    name: "services",
    components: {
        Header,
        Scroll,
        Cart
    },
    mounted() {
        this.getOrderList();
    },
    data() {
        return{
            hasNextPage: true,
            complaint:[],
            scrollParams: {
                pullDownRefresh: true,
                pullDownRefreshThreshold: 90,
                pullDownRefreshStop: 40,
                pullUpLoad: true,
                pullUpLoadThreshold: 0,
                pullUpLoadMoreTxt: "",
                pullUpLoadNoMoreTxt: "",
            },
            formPage: {
                pageSize: 10,
                currentPage: 1,
                totalRows: 0,
            },
        }
    },
    computed: {
    pullUpLoadObj() {
      return this.scrollParams.pullUpLoad
        ? {
            threshold: parseInt(this.scrollParams.pullUpLoadThreshold),
            txt: {
              more: this.scrollParams.pullUpLoadMoreTxt,
              noMore: this.scrollParams.pullUpLoadNoMoreTxt,
            },
          }
        : false;
    },
    pullDownRefreshObj() {
      return this.scrollParams.pullDownRefresh
        ? {
            threshold: parseInt(this.scrollParams.pullDownRefreshThreshold),
            stop: parseInt(this.scrollParams.pullDownRefreshStop),
          }
        : false;
    },
    dataEmpty() {
      return this.orderList.length == 0 && !this.loading;
    },
  },
  methods: {
    //   获取列表
    getOrderList(){
        transactionApi.getlistBuyerExpertConsult(Object.assign({},this.formPage)).then((res)=>{
            if (res.returnCode =='0'){
                this.complaint=res.result.dataList || [];
                for(var i in this.formPage){
                    this.formPage[i] = res.result[i];
                }
                 this.hasNextPage = res.result.hasNextPage;
                 if (this.hasNextPage) {
                    this.$refs.wrapper.forceUpdate(true);
                } else {
                    this.$refs.wrapper.forceUpdate(false);
                }
            }
        })
    },
    // 上拉加载
    onPullUpLoad() {
      if (!this.hasNextPage) {
        this.$refs.wrapper.forceUpdate(false);
        return false;
      } else {
        setTimeout(() => {
          this.formPage.currentPage++;
          this.getOrderList();
        }, 1000);
      }
    },
    //下拉刷新
    onPullDownRefresh() {
      setTimeout(() => {
        this.formPage.currentPage = 1;
        this.orderList = [];
        this.getOrderList();
      }, 1000);
    },
  }
}
</script>
<style lang="stylus">
    .order-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        .list-wrapper{
            width: 100%;
        }
        .tabs-container {
            flex: 1;
            display: flex;
            overflow: hidden;
        }
    }
</style>